import { Platform } from '@/types'

export interface PlatformOption {
  value: Platform
  label: string
}

export const PLATFORM_OPTIONS: PlatformOption[] = [
  { value: 'bolt', label: 'Bolt' },
  { value: 'uber', label: 'Uber' },
  { value: 'sumup', label: 'SumUp' },
  { value: 'friåkning', label: 'Friåkning' },
  { value: 'other', label: 'Annan' }
]

// Excluded from manual entry (used internally)
export const INTERNAL_PLATFORMS: Platform[] = []

// Get platform options for user selection (excluding internal ones)
export const getUserSelectablePlatforms = (): PlatformOption[] => {
  return PLATFORM_OPTIONS.filter(option => !INTERNAL_PLATFORMS.includes(option.value))
}

// Get platform label by value
export const getPlatformLabel = (value: Platform | 'total'): string => {
  if (value === 'total') return 'Totalt'
  const option = PLATFORM_OPTIONS.find(opt => opt.value === value)
  return option?.label || 'Okänd'
}

// Get platform names as a formatted string for UI display
export const getPlatformNamesText = (): string => {
  const names = PLATFORM_OPTIONS.map(option => option.label)
  if (names.length === 0) return ''
  if (names.length === 1) return names[0]
  if (names.length === 2) return `${names[0]} och ${names[1]}`
  return `${names.slice(0, -1).join(', ')} och ${names[names.length - 1]}`
}